import script from "./Business.vue?vue&type=script&setup=true&lang=ts"
export * from "./Business.vue?vue&type=script&setup=true&lang=ts"

import "./Business.vue?vue&type=style&index=0&id=32b2beba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32b2beba"]])

export default __exports__